import * as React from "react"
import {useEffect} from "react"
import {IconSeeker, TabsSeeker} from "@ui-seeker/core";

import {TABS_TABLE} from "../@contants";
import {PriceEvolutionShowMinMax, PriceEvolutionTabsTableID} from "../@signals";


export default function PriceEvolutionTabsTableBlock() {

	if (!PriceEvolutionTabsTableID.value)
		return <></>

    return <TabsSeeker
		showTabID={PriceEvolutionTabsTableID.value || TABS_TABLE.PRICING}
		onChange={(_, newValue) => PriceEvolutionTabsTableID.value = newValue}
		tabs={[{
			label: 'Table Daily Details',
			value: TABS_TABLE.PRICING,
			icon: <IconSeeker icon="calendar-week" />
		}, {
			label: 'Table Min/Max',
			value: TABS_TABLE.MIN_MAX,
			icon: <IconSeeker icon="circle-sort" />
		}]}
	/>
}